import { render, staticRenderFns } from "./CriminalStepTwo.vue?vue&type=template&id=3b86f290"
import script from "./CriminalStepTwo.vue?vue&type=script&lang=js"
export * from "./CriminalStepTwo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports